import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useQuery } from "@tanstack/react-query";

import { MissionsTransformer } from "../services/missionsTransformer";

export const useMission = (id?: string) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    queryKey: ['mission', id],
    enabled: Boolean(id),
    queryFn: async () => {
      const response = await privateAxios.get(`/tmais/missions/${id}`)
      const rawData = response.data?.data || response.data || {}
      const included = response.data?.included
      return MissionsTransformer.fromApi(rawData, included)
    },
  })
}
